// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__7qp6Z","payment-schedule-image":"payment-schedule-image__3Odx9","lead-text":"lead-text__3ZWeX","body":"body__wFR1O","calendar":"calendar__1h5Lp"};